import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
		
			<p class="mb-3">
				Я решила встретить Новый год на главной улице города. 
				Там стоит самая большая ёлка, а вокруг неё всегда собирается народ, чтобы вместе отпраздновать: веселиться, 
				пить шампанское и поздравлять совсем незнакомых людей, оказавшихся рядом; ведь праздник-то общий!
			</p>
			
			<p class="mb-3">
				Но на центральной улице не было ни единого человека! 
				Ёлка сверкала, переливалась огнями, но не было никого, чтобы любоваться ею. 
				Только ближе к полуночи появилось несколько автобусов, из которых вышли группы людей, одетых в чёрную форму. 
			</p>
			
			<p class="mb-3">
				Я заторопилась домой. 
				Но, не дойдя нескольких кварталов до дома, услышала звуки перестрелки. 
				Это был поединок мелких ракет и системы противовоздушной обороны (ПВО), стрелявшей по ним. 
				Всё небо, как праздничным салютом, было перечерчено сияющими трассирующими следами. 
			</p>
			
			<p class="mb-3">
				Но мне же надо домой! 
				А мой дом как раз там, куда направлены ракеты и где их сбивает ПВО. 
				А любой обломок с неба может прибить меня, одну на пустынной улице… 
				И вот иду я потихоньку, а в голове спорят только две мысли:
			</p>
			
			<p class="mb-3">
				– Надо домой, там хоть крыша над головой, и всё же это дом, укрытие…
			</p>
			
			<p class="mb-3">
				– Но там же стреляют!
			</p>
			
			<p class="mb-3">
				– Но мне надо домой!
			</p>
			
			<p class="mb-3">
				– Но там же стреляют!
			</p>
			
			<p class="mb-5">
				И вот так я иду: то постою, то снова иду. 
			</p>
			
			<p class="mb-3">
				Но всё же дошла!
			</p>
    </div>
    `
  )
}

const itemName = {
  rus: `Самый короткий рождественский рассказ`
}

const itemDate = {
	rus: "31 декабря 2023 г."
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
		itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

